<template>
  <div class="application-action-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="450px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="150px">
        <el-form-item label="机器人类型:" prop="type">
          <el-select v-model="params.type" size="small" clearable placeholder="请选择机器人类型">
            <el-option v-for="item in type" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="每日开始时间:" prop="from">
          <el-time-picker v-model="params.from" placeholder="请选择开始时间" size="small" @change="test" value-format="HH:mm:ss">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="每日结束时间:" prop="to">
          <el-time-picker v-model="params.to" placeholder="请选择结束时间" size="small" value-format="HH:mm:ss">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="每日评论总数:" prop="cover">
          <el-input v-model.number="params.totalLimit" size="small"></el-input>
        </el-form-item>
        <el-form-item label="单个机器人评论总数:">
          <el-input v-model.number="params.pureLimit" size="small"></el-input>
        </el-form-item>
        <el-form-item label="评论视频最大评论数:">
          <el-input v-model.number="params.maxCommentNum" size="small"></el-input>
        </el-form-item>
        <el-form-item label="视频点赞数最大值:">
          <el-input v-model.number="params.maxFakeLikes" size="small"></el-input>
        </el-form-item>
        <el-form-item label="视频点赞数最小值:">
          <el-input v-model.number="params.minFakeLikes" size="small"></el-input>
        </el-form-item>
        <el-form-item label="视频播放量最大值:">
          <el-input v-model.number="params.maxFakePlayCount" size="small"></el-input>
        </el-form-item>
        <el-form-item label="视频播放量最小值:">
          <el-input v-model.number="params.minFakePlayCount" size="small"></el-input>
        </el-form-item>
        <el-form-item label="发送频率(秒/条):">
          <el-input v-model.number="params.frequency" size="small"></el-input>
        </el-form-item>
        <el-form-item label="是否开启:">
          <el-switch v-model="params.isActive"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
export default {
  data() {
    return {
      title: '',
      flag: false,
      id: '',
      dialogVisible: false,
      type: [
        {
          label: '评论机器人',
          value: 'COMMENT'
        },
        {
          label: '影院机器人',
          value: 'FILM'
        }
      ],
      rules: {
        type: [
          { required: true, message: '请选择机器人类型', trigger: 'blur' },
        ],
        from: [
          { required: true, message: '请选择开始时间', trigger: 'blur' },
        ],
        to: [
          { required: true, message: '请选择结束时间', trigger: 'blur' },
        ],
      },
      params: {
        type: '',
        from: '',
        to: '',
        totalLimit: '',
        pureLimit: '',
        frequency: '',
        maxCommentNum: '',
        maxFakeLikes: '',
        minFakeLikes: '',
        maxFakePlayCount: '',
        minFakePlayCount: '',
        isActive: false,
      },
    }
  },
  methods: {
    test(time) {
      window.console.log(time)
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '编辑配置') {
            this.updateRbot()
          } else {
            this.addRobot()
          }
        }
      });
    },
    // 编辑推送
    updateRbot() {
      let params = Object.assign({}, this.params, { id: this.id })
      API.updateRbot(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerRobot')
        } else {
          this.$message.error('编辑失败')
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 新增推送
    addRobot() {
      API.addRbot(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerRobot')
        } else {
          this.$message.error('新增失败')
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        type: '',
        from: '',
        to: '',
        totalLimit: '',
        pureLimit: '',
        frequency: '',
        isActive: false,
      }
    },
    open(type, row) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑配置'
        this.params.id = row.id
        this.params.type = row.type
        this.params.from = row.from
        this.params.to = row.to
        this.params.totalLimit = row.totalLimit
        this.params.pureLimit = row.pureLimit
        this.params.frequency = row.frequency
        this.params.isActive = row.isActive
        this.params.maxCommentNum = row.maxCommentNum
        this.params.maxFakeLikes = row.maxFakeLikes
        this.params.minFakeLikes = row.minFakeLikes
        this.params.maxFakePlayCount = row.maxFakePlayCount
        this.params.minFakePlayCount = row.minFakePlayCount
      } else {
        this.title = '新增配置'
      }
    }
  }
}
</script>
<style scoped>
.el-input {
  width: 220px;
}
</style>